import type CSS from 'csstype';
import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import type { Variant } from './types';

type StyledQuotaBadgeProps = {
  $variant: 'info' | 'warning';
};

const VARIANT_TO_COLOR_MAP: Record<Variant, CSS.Property.Color> = {
  info: colorsPalettes.blue[100],
  warning: colorsPalettes.red[200],
};

export const StyledQuotaBadge = styled.div<StyledQuotaBadgeProps>`
  ${setFontVariant('queryBar1', colorsPalettes.midnight[400])};

  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;

  background-color: ${({ $variant }) => VARIANT_TO_COLOR_MAP[$variant]};
  border: 1px solid ${colorsPalettes.bluegrey[300]};
  border-radius: 4px;
`;
